// import ses from '../../v1-legacy/plugins/ses';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const up = async (knex)=>{
    await knex('nc_plugins').del().where({
        title: 'SES'
    });
};
const down = async (_)=>{
// await knex('nc_plugins').insert([ses]);
};
